//contacts consts for footer
export const contacts = {
    email: 'kairospeak.support@kairospeak.com',
    telegram: 'https://t.me/kairospeak',
    youtube: 'https://www.youtube.com/@kairospeak',
    twitter: 'https://x.com/@kaisospeak'
}